import {registerGraph} from '@/angular/modules/vrm-graph/config-utils';
import getCssVariable from '@/utils/css_properties';

registerGraph('defaultGraph', defaultGraph);

/* @ngInject */
function defaultGraph($timeout, $rootScope) {
    let defaultHeight = getCssVariable('--height-default-graph', 270);

    return {
        options: {
            chart: {
                zoomType: 'x',
                marginTop: 45,
                alignTicks: false,
                // Reflow after load to fill the container div if no fixed sizes specified
                events: {
                    load: function () {
                        // Force trigger Highcharts reflow to fit responsive container
                        $timeout(function () {
                            $rootScope.$broadcast('highchartsng.reflow');
                        }, 300);
                    },
                    selection: function (event) {
                        if (event.xAxis && event.xAxis[0]) {
                            let minPoints = -Infinity;
                            event.xAxis[0].axis.series.forEach(series => {
                                if (!series || !series.points) return;
                                const pointsInNewInterval = series.points.filter(point => {
                                    return point.x > event.xAxis[0].min && point.x < event.xAxis[0].max
                                }).length;
                                minPoints = Math.max(minPoints, pointsInNewInterval);
                            });
                            if (minPoints < 2) {
                                event.preventDefault();
                            }
                        }
                    }
                }
            },
            tooltip: {
                shared: true,
                animation: false,
                hideDelay: 0,
                headerFormat: ''
            },
            title: {
                text: ''
            },
            subtitle: {
                text: ''
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            }
        },
        size: {
            height: defaultHeight,
        },
        loading: true
    };
}
